import React from 'react';
import { Modal, ModalProps } from '@heroui/react';
import { useIsMobile } from '../../hooks/useMobile';

type ResponsiveModalProps = ModalProps & {
  mobilePlacement?: ModalProps['placement'];
};

export function ResponsiveModal({
  mobilePlacement = 'center',
  placement,
  classNames,
  ...props
}: ResponsiveModalProps) {
  const isMobile = useIsMobile();
  const resolvedPlacement = isMobile ? (placement ?? mobilePlacement) : placement;
  const resolvedClassNames = isMobile
    ? {
        ...classNames,
        base: `${classNames?.base ?? ''} max-w-[21.4375rem]`.trim(),
      }
    : classNames;

  return <Modal placement={resolvedPlacement} classNames={resolvedClassNames} {...props} />;
}
